<script setup>

import {ref} from "vue";

const templatesIndexComponent = ref(null)

const reloadTemplates = () => {
    templatesIndexComponent.value.getTemplates()
}

</script>
<template>
    <div>
        <div class="container w-full mx-auto mb-12 md:sticky top-2 z-topbar">
            <frosted-bar>
                <div class="flex items-center justify-between space-x-4">
                    <h1>
                        {{ _mft('pagebuilderTemplate:domainNamePlural') }}
                    </h1>

                    <div class="flex items-center space-x-4">
                        <story-lane-modal :module="'templates'"></story-lane-modal>
                    </div>
                </div>
            </frosted-bar>
        </div>

        <template-invitations
            @reload="reloadTemplates"
            class="mb-24 xl:mt-8"
        />

        <templates-list
            ref="templatesIndexComponent"
        />
    </div>
</template>
